import { useAppSelector } from '#app/store'
import { selectOrderedConfigurations } from '#store/selectors/orderedTruckConfigurations'

export const maxAllowedConfigurationCount = 3

export const useCanOpenMoreConfigurations = () => {
  const orderedConfigurations = useAppSelector(selectOrderedConfigurations)
  return orderedConfigurations.length < maxAllowedConfigurationCount
}
